import type { FinanceRepository } from '@zetyar/data-contracts'
import { createSupabaseFinanceRepository } from '@zetyar/supabase-client'
import { getSupabaseClient } from '@/infrastructure/supabase/app'

export const webFinanceRepository: FinanceRepository = createSupabaseFinanceRepository(getSupabaseClient())
